import React, { useState } from 'react';
import { Dialog, DialogContent, Typography, Button, Box, Stack, CircularProgress } from '@mui/material';

interface Props {
  open: boolean;
  onClose: () => void;
  onDelete: () => Promise<void>;
  personName: string;
  companyName: string;
}

const GrantDeleteModal: React.FC<Props> = ({ open, onClose, onDelete, personName, companyName }) => {
  const [loading, setLoading] = useState(false);

  const handleDelete = async () => {
    setLoading(true);
    try {
      await onDelete();
      onClose();
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          p: 1,
        },
      }}
    >
      <DialogContent>
        <Box pb={2}>
          <Typography fontSize={20} fontWeight={700} color="grey.800" mb={2}>
            Confirmar remoção de acesso
          </Typography>
          <Typography fontSize={14} color="grey.700" mb={3}>
            Tem certeza que deseja remover o acesso de <b>{personName}</b> à <b>{companyName}</b>?
          </Typography>
        </Box>
        <Stack direction="row" spacing={2} justifyContent="space-between">
          <Button onClick={onClose} disabled={loading} variant="outlined" fullWidth>
            Cancelar
          </Button>

          <Button
            onClick={handleDelete}
            color="error"
            variant="contained"
            disableElevation
            disabled={loading}
            startIcon={loading ? <CircularProgress size={20} /> : undefined}
            fullWidth
          >
            Remover acesso
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default GrantDeleteModal;
